import { useCallback } from 'react'
import { appendImpersonationToken } from '@/utils/impersonation'

export function useImpersonationPath() {
  return useCallback((path: string) => appendImpersonationToken(path), [])
}
